import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { Trans } from 'lingui-react';
import { H4, P } from 'base-components';
import { px2rem } from 'decisiv-ui-utils';

import TextDiv from 'elements/TextDiv';

import Wrapper from './Wrapper';

function WizardSearchError({ searchValue, titlePrefix, titleSuffix, subtitle }) {
  const isNoSearch = searchValue === '';
  const marginValue = isNoSearch ? px2rem(20) : px2rem(6);

  return (
    <Wrapper>
      <FontAwesome name="search" />
      {!isNoSearch &&
        <H4 modifiers={['fontWeightRegular']} style={{ marginTop: px2rem(20) }}>
          <Trans id={titlePrefix} />
          <TextDiv modifiers={['bold', 'inline']}>
            {`${searchValue}`}
          </TextDiv>
          <Trans id={titleSuffix} />
        </H4>
      }
      <P
        modifiers={['textLight']}
        style={{ marginTop: marginValue }}
      >
        <Trans id={subtitle} />
      </P>
    </Wrapper>
  );
}

WizardSearchError.propTypes = {
  searchValue: PropTypes.string.isRequired,
  titlePrefix: PropTypes.string.isRequired,
  titleSuffix: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default WizardSearchError;



// WEBPACK FOOTER //
// ./components/WizardSearchError/index.js